<div>


  <mat-card>
    <mat-card-header class="titreFrm">
      <mat-card-title>PARAM&Eacute;TRE collaborateur</mat-card-title>
    </mat-card-header>
    <mat-card-content class="border">
      <div *ngIf="exist;else attente"></div>
      <ng-template #attente>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </ng-template>
      <mat-card class="example-card carClass">
        <mat-card-content>
          <form class="example-form" #f="ngForm">
            <mat-form-field     appearance="outline"  style="width: 70px;">
              <mat-label>Code</mat-label>
              <input matInput name="DiverSys_Index" #DiverSys_Index="ngModel" [(ngModel)]="data.DiverSys_Index"
                placeholder="Code" required>
            </mat-form-field>
            <mat-form-field     appearance="outline"   style="width: 200px;">
              <mat-label>Type</mat-label>
              <input matInput name="DiverSys_Titre" #DiverSys_Titre="" [(ngModel)]="data.DiverSys_Titre"
                placeholder="Type" required>
            </mat-form-field>
            <mat-form-field     appearance="outline"  style="width: 300px;">
              <mat-label>Détaille</mat-label>
              <input matInput name="DiverSys_Libelle" #DiverSys_Libelle="ngModel"
                [(ngModel)]="data.DiverSys_Libelle" placeholder="Détaille">
            </mat-form-field>

            <span class="button-row">
              <button (click)="ajouter(f)" [disabled]="disabledBtnAjouter" mat-raised-button
                class="colorGreen">Ajouter</button>
            </span>
          </form>
        </mat-card-content>
      </mat-card>
      <mat-card class="example-card carClass">
        <mat-card-content>
          <div fxLayout="row" fxLayoutAlign="space-between none">
           
            <div fxLayout="row">
              <div style="margin-right: 20px" class="button-row">
                <button (click)="modifier()" [disabled]="disabledBtnModifier" mat-raised-button
                  class="colorGreen">Modifier</button>
              </div>

              <div style="margin-right: 20px" class="button-row">
                <button (click)="supprimer()" mat-raised-button class="colorRed">Supprimer</button>
              </div>
            </div>
          </div>
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <ng-container matColumnDef="DiverSys_Index">
              <th mat-header-cell *matHeaderCellDef> Code </th>
              <td mat-cell *matCellDef="let element">
                {{element.DiverSys_Index}}
              </td>

            </ng-container>
            <ng-container matColumnDef="DiverSys_Titre">
              <th mat-header-cell *matHeaderCellDef>Type </th>
              <td mat-cell *matCellDef="let element">
                <mat-form-field     appearance="outline"  class="example-full-width">
                  <input matInput [name]="'DiverSys_Titre'+element.DiverSys_Index" #DiverSys_Titre=""
                    [(ngModel)]="element.DiverSys_Titre" required>
                </mat-form-field>
              </td>
            </ng-container>
            <ng-container matColumnDef="DiverSys_Libelle">
              <th mat-header-cell *matHeaderCellDef>Détaille </th>
              <td mat-cell *matCellDef="let element">
                <mat-form-field     appearance="outline"  class="example-full-width">
                  <input matInput [name]="'DiverSys_Libelle'+element.DiverSys_Index" #DiverSys_Libelle="ngModel"
                    [(ngModel)]="element.DiverSys_Libelle">
                </mat-form-field>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectRow($event,row)"></tr>
          </table>
        </mat-card-content>
      </mat-card>
      <br>
    </mat-card-content>
  </mat-card>
</div>